// extracted by mini-css-extract-plugin
module.exports = {"main":"Intro_main__qaRwC","banner":"Intro_banner__fya_t","subtitle":"Intro_subtitle__Htzjv","button":"Intro_button__XQ7Vx"};